'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var CodeIcon = function CodeIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === undefined ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['color', 'size', 'filled', 'className', 'children']);

  var classes = 'calcite-icon';
  if (className) classes += ' ' + className;

  if (size <= 16) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 16 16',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M2.714 12L0 8l2.714-4h2.175L2.175 8l2.714 4zM8.579 2L5.484 14h1.858l3.096-12zm2.532 2l2.714 4-2.714 4h2.175L16 8l-2.713-4z'
    }) : _react2.default.createElement('path', {
      d: 'M6.865 13.965l-.957-.29 3.213-10.62.957.29zM15.19 8.45l-3.837-3.805-.704.71 3.131 3.104-3.135 3.19.712.702zm-9.833 3.2L2.221 8.458l3.13-3.104-.703-.71L.811 8.45l3.833 3.9z'
    }));
  }

  if (size <= 24) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 24 24',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M16 19l5.532-6.5L16 6h2.468L24 12.5 18.468 19zM5.532 6L0 12.5 5.532 19H8l-5.532-6.5L8 6zm7.353-2c-2.224 8.617.504-1.962-4.385 17h1.857c.956-3.703 3.269-12.669 4.385-17z'
    }) : _react2.default.createElement('path', {
      d: 'M9.916 20.95l-.97-.241 4.138-16.66.97.242zm7.438-2.596l-.707-.707 5.146-5.147-5.147-5.146.707-.707 5.854 5.853zm-10.707 0L.792 12.5l5.853-5.854.707.707L2.207 12.5l5.146 5.146z'
    }));
  }

  return _react2.default.createElement('svg', _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: '0 0 32 32',
    className: classes
  }), filled ? _react2.default.createElement('path', {
    d: 'M21 25l7.689-8.5L21 8h2.312L31 16.5 23.312 25zM8.688 8L1 16.5 8.688 25H11l-7.689-8.5L11 8zm9.317-3l-.332 1.285c-2.723 10.553.479-1.862-4.775 18.513L12.072 28h1.857l.773-2.993L19.604 6l.258-1z'
  }) : _react2.default.createElement('path', {
    d: 'M12.854 26.977l-.96-.275 6.184-21.679.961.275zM30.207 16.5l-6.853-6.854-.707.707 6.146 6.147-6.146 6.146.707.707zM9.354 22.646L3.206 16.5l6.148-6.174-.709-.706-6.851 6.882 6.852 6.853z'
  }));
};

exports.default = CodeIcon;